<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="form" :rules="rules" ref="form" label-width="140px">
        <!-- <el-form-item label="用户类型" prop="userType">
          <custom-select v-model="form.userType" type="dict" :data="userType"></custom-select>
        </el-form-item> -->
        <el-form-item label="登录账号" prop="loginId">
          <el-input :disabled="!!userId" v-model="form.loginId" placeholder="请输入登录账号"/>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="form.mobile" maxlength="11" placeholder="请输入手机号"/>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <!-- <el-input v-model="form.password" type="password" placeholder="请输入密码"/> -->
          <span>默认密码是手机号后六位</span>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="form.roleId" filterable>
            <el-option :label="item.roleName" :value="item.roleId" v-for="(item, index) of roles" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="部门" prop="deptId">
          <el-cascader
            ref="cascader"
            v-model="form.deptId"
            :show-all-levels="false"
            :options="depts"
            @change="closeCascader"
            :props="{ emitPath: false, label: 'deptName', value: 'deptId', children: 'childNode', checkStrictly: true }">
          </el-cascader>
        </el-form-item> -->
        <el-form-item label="名称" prop="userName">
          <el-input v-model="form.userName" placeholder="请输入名称"/>
        </el-form-item>
        <!-- 员工账号的 userNo 用于 T+ 单据经手人编码。 -->
        <el-form-item label="经手人编码" prop="userNo">
          <el-input v-model.trim="form.userNo" placeholder="请输入经手人编码"/>
        </el-form-item>
        <el-form-item label="是否部门负责人" prop="isLeader">
          <el-radio-group v-model="form.isLeader">
            <el-radio label="1">是</el-radio>
            <el-radio label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属部门" prop="deptId">
          <el-cascader
            ref="cascader"
            v-model="form.deptId"
            :show-all-levels="false"
            :options="treeData"

            :props="{ emitPath: false, label: 'deptName', value: 'deptId', children: 'childNode', checkStrictly: true }"
            @change="deptChange">
          </el-cascader>
        </el-form-item>
        <!-- <el-form-item label="证件类型" prop="idCardTypeNum"></el-form-item>
        <el-form-item label="证件号码" prop="idCard">
          <el-input v-model="form.idCard" placeholder="请输入证件号码"/>
        </el-form-item>
        <el-form-item label="健康证有效日期" prop="healthyEndDate">
          <el-date-picker v-model="form.healthyEndDate" value-format="yyyy-MM-dd" type="date" placeholder="请选择截止日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker v-model="form.birthday" value-format="yyyy-MM-dd" type="date" placeholder="请选择出生日期"></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button">保存</el-button>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'AccountAdd',
  data () {
    return {
      userType: [],
      roles: [],
      depts: [],
      form: {
        loginId: '', // 登录账号
        mobile: '', // 手机号
        roleId: '', // 用户角色
        password: '', // 密码
        userType: '1', // 这个页面默认是创建员工
        isLeader: '', // 是否部门负责人
        userName: '', // 名称
        userNo: '', // T+ 经手人编码，新增和编辑时随账号资料提交
        deptId: ''
      },
      rules: {
        // userType: [{ required: true, message: '请选择用户类型' }],
        loginId: [{ required: true, message: '请输入登录账号' }],
        mobile: [{ required: true, message: '请输入手机号' }],
        roleId: [{ required: true, message: '请选择角色' }],
        isLeader: [{ required: true, message: '请选择' }],
        // password: [{ required: true, message: '请输入密码' }],
        userName: [{ required: true, message: '请输入名称' }],
        deptId: [{ required: true, message: '请选择所属部门' }]
        // deptId: [{ required: true, message: '请选择部门' }],
        // unitId: [{ required: true, message: '请选择所属企业' }]
      },
      treeData: []
    }
  },
  computed: {
    userId () {
      return this.$route.query.userId
    },
    user () {
      return this.$store.state.user
    },
    unitData () {
      return this.$store.state.unitList
    }
  },
  created () {
    // this.form.userType = this.user.userType
    // this.loadDict()
    this.loadTree()
    this.loadRoles()
    // this.loadDepts()
    if (this.userId) {
      this.loadDetails()
    }
  },
  methods: {
    loadTree() {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.treeData = res
      })
    },
    deptChange () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadDetails () {
      this.$axios.get(this.$apis.system.selectSysUserByUserId, {
        params: { userId: this.userId }
      }).then(res => {
        this.form = res
      })
    },
    submit () {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.system.insertSysUser
        if (this.userId) {
          url = this.$apis.system.updateSysUser
        }
        this.$axios.post(url, this.form).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    },
    loadRoles () {
      this.$axios.get(this.$apis.system.selectSysRoleByList).then(res => {
        this.roles = res
      })
    },
    loadDepts () {
      this.$axios.get(this.$apis.system.selectSysDeptByList).then(res => {
        this.depts = res
      })
    },
    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    },
    loadDict () {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'userType' }
      }).then(res => {
        this.userType = res.userType
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-input,
.el-select,
.el-cascader {
  width: 300px;
}
</style>
